import React, { useEffect, useState, useRef } from 'react';
import { Link } from "react-router-dom";

import "./Home.scss";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";

import CountUp from 'react-countup';

import Client from '../Components/Client';
import Testimonial from '../Components/Testimonial';
import CallAction from '../Components/CallAction';

import BgVd1 from "./../Images/bg1.gif";
import BgVd2 from "./../Images/bg2.gif";

import FwImg1w from "./../Images/fw-slide1.webp";
import FwImg1 from "./../Images/fw-slide1.jpg";
import FwImg2w from "./../Images/fw-slide2.webp";
import FwImg2 from "./../Images/fw-slide2.jpg";
import FwImg3w from "./../Images/fw-slide3.webp";
import FwImg3 from "./../Images/fw-slide3.jpg";
import FwImg4w from "./../Images/fw-slide4.webp";
import FwImg4 from "./../Images/fw-slide4.jpg";

import BrndVid from "./../Images/showcase.mp4";

import ServImg1w from "./../Images/serv-icon1.webp";
import ServImg1 from "./../Images/serv-icon1.png";
import ServImg2w from "./../Images/serv-icon2.webp";
import ServImg2 from "./../Images/serv-icon2.png";
import ServImg3w from "./../Images/serv-icon3.webp";
import ServImg3 from "./../Images/serv-icon3.png";
import ServImg4w from "./../Images/serv-icon4.webp";
import ServImg4 from "./../Images/serv-icon4.png";
import ServImg5w from "./../Images/serv-icon5.webp";
import ServImg5 from "./../Images/serv-icon5.png";
import ServImg6w from "./../Images/serv-icon6.webp";
import ServImg6 from "./../Images/serv-icon6.png";

import FeatImg1w from "./../Images/feat1.webp";
import FeatImg1 from "./../Images/feat1.jpg";
import FeatImg2w from "./../Images/feat2.webp";
import FeatImg2 from "./../Images/feat2.jpg";
import FeatImg3w from "./../Images/feat3.webp";
import FeatImg3 from "./../Images/feat3.jpg";
import FeatImg4w from "./../Images/feat4.webp";
import FeatImg4 from "./../Images/feat4.jpg";
import FeatImg5w from "./../Images/feat5.webp";
import FeatImg5 from "./../Images/feat5.webp";
import FeatImg6w from "./../Images/feat6.webp";
import FeatImg6 from "./../Images/feat6.webp";
import FeatImg7w from "./../Images/feat7.webp";
import FeatImg7 from "./../Images/feat7.jpg";
import FeatImg8w from "./../Images/feat8.webp";
import FeatImg8 from "./../Images/feat8.jpg";
import FeatImg9w from "./../Images/feat9.webp";
import FeatImg9 from "./../Images/feat9.jpg";
import FeatImg10w from "./../Images/feat10.webp";
import FeatImg10 from "./../Images/feat10.jpg";

import VMImgw from "./../Images/santhosh-sam.webp";
import VMImg from "./../Images/santhosh-sam.png";

const FWList = [
    { srset1: FwImg1w, srset2: FwImg1, title: "ECCT" },
    { srset1: FwImg2w, srset2: FwImg2, title: "siddha Ayur" },
    { srset1: FwImg3w, srset2: FwImg3, title: "Extra Co." },
    { srset1: FwImg4w, srset2: FwImg4, title: "BTS" },
]

const ServList = [
    { class: "service-list service-list1 col-xl-10 col-md-9 col-18", direct: "fade-down", delay: "0", dataCol: "eq-ht2", srset1: ServImg1w, srset2: ServImg1, title: "Branding", class2: "mxw-400", para: "From logo to legacy, A 360° branding solution that shapes trust and perception." },
    { class: "service-list service-list2 col-xl-8 col-md-9 col-18", direct: "fade-down", delay: "200", dataCol: "eq-ht2", srset1: ServImg2w, srset2: ServImg2, title: "SEO", class2: "mxw-300", para: "End-to-end SEO & growth strategies that drive visibility, leads & revenue." },
    { class: "service-list service-list3 col-md-7 col-18", direct: "fade-right", delay: "400", srset1: ServImg3w, srset2: ServImg3, title: "Web Development", class2: "mxw-400", para: "Design, develop, host & manage, scale-your complete digital presence." },
    { class: "service-list service-list4 col-md-11 col-18", direct: "fade-left", delay: "600", srset1: ServImg4w, srset2: ServImg4, title: "Photography", class2: "mxw-450", para: "Showcase products, define brands-professional images for every business need." },
    { class: "service-list service-list5 col-md-11 col-18", direct: "fade-left", delay: "700", srset1: ServImg5w, srset2: ServImg5, title: "Videography", class2: "mxw-400", para: "Story-driven, full-stack video production for ads, reels & brand films." },
    { class: "service-list service-list6 col-18 mb-0", direct: "fade-up", delay: "700", srset1: ServImg6w, srset2: ServImg6, title: "Broadcasting", class2: "mxw-400", para: "Broadcast-grade live & on-demand content with zero compromise on quality." },
]

const FeatList = [
    { srset1: FeatImg1w, srset2: FeatImg1, title: "ANM Classes" },
    { srset1: FeatImg2w, srset2: FeatImg2, title: "Ever Bowl" },
    { srset1: FeatImg3w, srset2: FeatImg3, title: "Kans One" },
    { srset1: FeatImg4w, srset2: FeatImg4, title: "Let's Play" },
    { srset1: FeatImg5w, srset2: FeatImg5, title: "Maynee Cosmetology clinic" },
    { srset1: FeatImg6w, srset2: FeatImg6, title: "Super Auto Forge" },
    { srset1: FeatImg7w, srset2: FeatImg7, title: "TensileX" },
    { srset1: FeatImg8w, srset2: FeatImg8, title: "ZYX Media" },
    { srset1: FeatImg9w, srset2: FeatImg9, title: "ZYX Media" },
    { srset1: FeatImg10w, srset2: FeatImg10, title: "ZYX Media" },
]

const BenefitList = [
    { title: "Affordable solution", class: "benefit-list1", delay: "400" },
    { title: "Custom Design Solution", class: "benefit-list2", delay: "800" },
    { title: "Real-Time Collaboration", class: "benefit-list3", delay: "1200" },
    { title: "Integrated workflow", class: "benefit-list4", delay: "1600" },
]

export default function Home() {
    const settings = {
        infinite: true,
        speed: 500,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: 930,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '40px',
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '30px',
                },
            },
        ],
    };

    const overviewRef = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setTimeout(() => {
                        setInView(true);
                    }, 1000);
                    observer.disconnect();
                }
            },
            { threshold: 0.5 }
        );

        if (overviewRef.current) {
            observer.observe(overviewRef.current);
        }

        return () => observer.disconnect();
    }, []);

    const settings2 = {
        infinite: true,
        speed: 500,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: 930,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    const handleContactClick = () => {
        window.dispatchEvent(new Event("scrollToForm"));
    };

    useEffect(() => {
        const handleResize = () => {
            setTimeout(() => {
                var i = 0;
                var set = 0;
                var cols = document.querySelectorAll("[data-col]");
                var encountered = [];
                for (i = 0; i < cols.length; i++) {
                    var attr = cols[i].getAttribute("data-col");
                    if (encountered.indexOf(attr) === -1) {
                        encountered.push(attr);
                    }
                }
                for (set = 0; set < encountered.length; set++) {
                    var col = document.querySelectorAll(
                        '[data-col="' + encountered[set] + '"]'
                    );
                    var group = [];
                    for (i = 0; i < col.length; i++) {
                        col[i].style.height = "auto";
                        var elementHeight = col[i].offsetHeight;
                        group.push(elementHeight);
                    }
                    for (i = 0; i < col.length; i++) {
                        col[i].style.height = "auto";
                        col[i].style.height = Math.max.apply(Math, group) + "px";
                    }
                }
            }, 500);
        };
        window.addEventListener("resize", handleResize);
        handleResize();
    }, []);

    return (
        <>
            <div className='banner'>
                <div className='video-bg1'><img src={BgVd1} alt='' /></div>
                <div className='container-fluid'>
                    <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                        <tbody>
                            <tr><td>
                                <div className='txt-center'>
                                    <div className='glow-btn cursor-a' data-aos="fade-up" data-aos-once='true'>
                                        <span className='f-18 mb-0 pe-4'><span className='f-18 mb-0 fw-600'>100+</span> Success Stories & loading... <span className='avatar-list-stacked ms-2'><span className='avatar avatar1'></span><span className='avatar avatar2'></span><span className='avatar avatar3'></span></span></span>
                                    </div>
                                </div>
                                <div className='mxw-850 m-auto banner-head' data-aos="fade-up" data-aos-once='true' data-aos-delay="200"><h1 className='fw-300 txt-center'>Slingshot your Ideas into Disruptive Business</h1></div>
                                <div className='mxw-850 m-auto banner-txt' data-aos="fade-up" data-aos-once='true' data-aos-delay="400"><p className='f-18 mb-0 txt-center line-ht-24'>Turn your headaches into headstart with ZYX. Let's communicate, execute and expand together to bring meaningful connections that solve business problems that converts  and contemplates growth...</p></div>
                            </td></tr>
                        </tbody>
                    </table>
                </div>
                <div className='video-bg2'><img src={BgVd2} alt='' /></div>
            </div>
            <div className='fw-slider-cont bg-pattern'>
                <div className='container-fluid pb-5'>
                    <Slider className='fw-slider' {...settings}>
                        {FWList.map((item, index) => {
                            return (
                                <div key={index} data-aos="fade-up" data-aos-once='true' data-aos-delay="600">
                                    <picture>
                                        <source srcSet={item.srset1} type="image/webp" />
                                        <source srcSet={item.srset2} type="image/jpeg" />
                                        <img
                                            src={item.srset2}
                                            alt={item.title}
                                            title={item.title}
                                            width="1000"
                                            height="1000"
                                        />
                                    </picture>
                                </div>
                            )
                        })}
                    </Slider>
                </div>
            </div>
            <div className='brand-vid-cont bg-pattern'>
                <div className='container-fluid'>
                    <div className='mxw-1200 m-auto pse-2'>
                        <div className='bv-cont' data-aos="fade-up" data-aos-once='true' data-aos-delay="600">
                            <video src={BrndVid} autoPlay loop muted playsInline width="100%" height="auto" />
                        </div>
                    </div>
                </div>
            </div>
            <div className='overview-cont bg-pattern' ref={overviewRef}>
                <div className='container-fluid sectin'>
                    <div className='row'>
                        <div className='col-xl-11 col-18 overview-lt-ct mb-xl-0' data-col="eq-ht">
                            <h2 className='h1 fw-300 mb-8' data-aos="fade-down" data-aos-once='true'>Collaborate with ZYX</h2>
                            <p className='f-18 mb-0 line-ht-24' data-aos="fade-up" data-aos-once='true' data-aos-delay="400">Our story is weaved in creativity, binded by technology and aspired through milestones and fueled by continuous innovation.  We at ZYX helped numerous small and mediums sized businesses to transform ideas to reach their potential customers and marketplaces.  Join hands to  get awareness, engagement, & revenue to bring your vision that helps solve people's problem.</p>
                        </div>
                        <div className='col-xl-5 col-18 float-xl-end overview-rt-ct mb-0' data-col="eq-ht">
                            <ul className='row'>
                                <li className='col-xl-18 col-sm-9 col-18 mb-sm-0' data-aos="fade-left" data-aos-once='true' data-aos-delay="600">
                                    <h2 className='h1 fw-300 mb-8'>{inView && <CountUp className='d-in-blk fw-300' start={0} end={55} />}+</h2>
                                    <p className='f-18 mb-0 line-ht-24'>continuing client collaborations across diverse portfolios and industrial disciplines</p>
                                    <div className='clear'></div>
                                </li>
                                <li className='col-xl-18 col-sm-9 col-18 mb-0' data-aos="fade-left" data-aos-once='true' data-aos-delay="1000">
                                    <h2 className='h1 fw-300 mb-8'>{inView && <CountUp className='d-in-blk fw-300' start={0} end={20} />}k+</h2>
                                    <p className='f-18 mb-0 line-ht-24'>hours of human hours involved in creating inspiring stories through videos, podcasts, creatives, marketing activities and much more.</p>
                                    <div className='clear'></div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className='services-cont fix'>
                <div className='video-bg1'><img src={BgVd1} alt='' /></div>
                <div className='container-fluid sectin'>
                    <h2 className='h1 fw-300 mb-8 txt-lg-center txt-lt' data-aos="fade-down" data-aos-once='true'>We Deliver!</h2>
                    <div className='mxw-750 m-lg-auto txt-lg-center txt-lt mb-8' data-aos="fade-down" data-aos-once='true'><p className='f-18 mb-0 line-ht-24'>We blend creativity and technology to elevate your brand's story. Engage your audience and achieve your business goals with ZYX's marketing & strategic approach.</p></div>
                    <div className='row'>
                        {ServList.map((item, index) => {
                            return (
                                <div key={index} className={item.class} data-aos={item.direct} data-aos-once='true' data-aos-delay={item.delay}>
                                    <div {...(item.dataCol ? { 'data-col': item.dataCol } : {})}>
                                        <div className='serv-icon'>
                                            <picture>
                                                <source srcSet={item.srset1} type="image/webp" />
                                                <source srcSet={item.srset2} type="image/png" />
                                                <img src={item.srset2} alt={item.title} title={item.title} width="54" height="54" />
                                            </picture>
                                        </div>
                                        <div className='serv-dts'>
                                            <h6 className='h7 fw-400 mb-3'>{item.title}</h6>
                                            <div className={item.class2}><p className='f-20 line-ht-26 mb-0'>{item.para}</p></div>
                                        </div>
                                        <div className='clear'></div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className='video-bg2'><img src={BgVd2} alt='' /></div>
            </div>
            <Client />
            <div className='featured-works-cont fix'>
                <div className='video-bg1'><img src={BgVd1} alt='' /></div>
                <div className='container-fluid sectin'>
                    <h2 className='h1 fw-300 mb-8 txt-lg-center txt-lt' data-aos="fade-down" data-aos-once='true'>Our Featured Works</h2>
                    <div className='mxw-700 m-lg-auto txt-lg-center txt-lt mb-8' data-aos="fade-down" data-aos-once='true'><p className='f-18 mb-0 line-ht-24'>A showcase of bold ideas and real impact-branding, design & digital campaigns crafted for visionary clients across industries.</p></div>
                    <Slider className='feat-slider' {...settings2}>
                        {FeatList.map((item, index) => {
                            return (
                                <div key={index} data-aos="fade-up" data-aos-once='true' data-aos-delay="200">
                                    <picture>
                                        <source srcSet={item.srset1} type="image/webp" />
                                        <source srcSet={item.srset2} type="image/jpeg" />
                                        <img src={item.srset2} alt={item.title} title={item.title} width="1000" height="1250" />
                                    </picture>
                                </div>
                            )
                        })}
                    </Slider>
                    <div className='txt-center mt-4'><Link to="/Portfolio" className='f-18 txt-white-60 txt-underline mb-0'>Load More</Link></div>
                </div>
            </div>
            <div className='benefits-cont'>
                <div className='container-fluid sectin'>
                    <div className='row'>
                        <div className='col-lg-8 col-18 benefits-lt-ct mb-xl-0' data-col="eq-ht3">
                            <h2 className='h1 fw-300 mb-8' data-aos="fade-down" data-aos-once='true'>Have queries?</h2>
                            <p className='mxw-700 m-lg-auto f-18 mb-8 line-ht-24' data-aos="fade-up" data-aos-once='true' data-aos-delay="400">We're just a message away. Whether it's a project idea or a quick doubt, our team is here to assist you with clarity, speed, and zero jargon.</p>
                            <div data-aos="fade-up" data-aos-once='true' data-aos-delay="400"><Link className="glow-btn" onClick={handleContactClick}><span>Contact Us</span></Link></div>
                        </div>
                        <div className='col-xl-9 col-lg-8 col-18 float-lg-end benefits-rt-ct mb-0' data-col="eq-ht3">
                            <ul>
                                {BenefitList.map((item, index) => {
                                    return (
                                        <li key={index} className={item.class} data-aos="fade-left" data-aos-once='true' data-aos-delay={item.delay}><div className='h8 fw-400'>{item.title}</div></li>
                                    )
                                })}
                            </ul>
                            <div className='txt-lg-lt txt-center' data-aos="fade-up" data-aos-once='true' data-aos-delay="400"><Link className="glow-btn"><span>Contact Us</span></Link></div>
                        </div>
                    </div>
                </div>
            </div>
            <Testimonial />
            <div className='vm-cont bg-pattern'>
                <div className='container-fluid sectin'>
                    <h2 className='h1 fw-300 mb-8 txt-lt mxw-400 m-auto'>Vision & Mission</h2>
                    <div className='row'>
                        <div className='col-md-9 col-18 vm-lt-ct mb-lg-0' data-aos="fade-right" data-aos-once='true'><div className='mxw-450 m-auto' data-col="eq-ht6">
                            <picture>
                                <source srcSet={VMImgw} type="image/webp" />
                                <source srcSet={VMImg} type="image/png" />
                                <img src={VMImg} alt="Santhosh SK - Founder & Sam Deva Anbu MS - Director" title="Santhosh SK - Founder & Sam Deva Anbu MS - Director" width="434" height="507" />
                            </picture>
                        </div></div>
                        <div className='col-md-9 col-18 vm-rt-ct mb-0'><div className='mxw-400 m-auto' data-col="eq-ht6">
                            <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                <tbody>
                                    <tr><td>
                                        <h2 className='h1 fw-300 mb-8 txt-lt' data-aos="fade-down" data-aos-once='true'>Vision & Mission</h2>
                                        <p className='f-18 line-ht-24' data-aos="fade-up" data-aos-once='true' data-aos-delay="400">At ZYX Media, we turn ideas into experiences that matter. We partner with brands to create thoughtful design, compelling stories, and smart digital solutions that don't just look good—they work. Whether it's strategy, SEO, branding, or web development, we focus on building things that connect, last, and deliver measurable impact.</p>
                                        <p className='f-18 line-ht-24' data-aos="fade-up" data-aos-once='true' data-aos-delay="600">We believe creativity and technology should serve purpose—and that meaningful work is always a collaboration.</p>
                                    </td></tr>
                                </tbody>
                            </table>
                        </div></div>
                    </div>
                </div>
            </div>
            <CallAction />
        </>
    )
}
